'use client'

import { useEffect } from 'react'

// Module-level guard: load the stylesheet once per app load, even if the
// component remounts (e.g. React Strict Mode double-invoking effects).
let requested = false

/**
 * Loads non-critical vendor CSS (cookie banners, Google CSE, Guuru chat,
 * PhotoSwipe, Tomas) after the window `load` event, so it doesn't compete
 * with the render-blocking CSS needed for LCP.
 */
export default function DeferredStyles() {
  useEffect(() => {
    if (requested) {
      return
    }
    requested = true

    const load = () => {
      void import('@/styles/deferred.css')
    }

    if (document.readyState === 'complete') {
      load()
    } else {
      window.addEventListener('load', load, { once: true })
    }
  }, [])

  return null
}
